import { convertIntToDate } from './stringUtils'
import { colorForIdStable } from '@/utils/color/palette'
import type { BaseChartData } from '@/api/chart/chart.service'

export const makeSingleDomainData = (
  chartResponse: BaseChartData,
  schoolColors: { [id: string]: string },
  labels?: { [id: string]: string },
) => {
  return Object.entries(chartResponse.xyPointsPerSchoolId).map((entry) => {
    const schoolId = entry[0]
    const points = entry[1].sort((a, b) => (a.x < b.x ? -1 : 1))
    const data = points.map(({ x, y }) => ({
      x: convertIntToDate(x),
      y: y,
    }))
    return {
      id: labels?.[schoolId] ?? schoolId,
      data: data,
      color:
        schoolColors[schoolId] !== undefined ? schoolColors[schoolId] : colorForIdStable(schoolId),
    }
  })
}
